import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/front_end/src/app/(main)/questions/create/components/register_message.tsx");
